<template>
  <b-card no-body class="root mb-2" style="overflow: hidden;" tag="div">
    <div v-if="playlist.isEmpty || loading" class="text-light2 bg-light">
      <div style="padding: 20% 0 37%; text-align: center; font-size: 40px; height: 0;">
        <loader />
      </div>
    </div>
    <LazyImage
      v-else
      :src="playlist.image"
      :width="playlist.image_width"
      :height="playlist.image_height"
    >
      <template slot="title">
        <h5>{{ playlist.title }}</h5>
        <span>{{ playlist.tagline }}</span>
      </template>

      <router-link
        tag="div"
        class="clickable link"
        :to="
          playlist.isEmpty || playlist.portal == 'GLAD'
            ? ''
            : { name: 'playlist', params: { id: playlist.id } }
        "
        @click.native="$emit('open')"
      />
      <BodyPartsTimeIndicator :areas="playlist.areas" :time="playlist.duration" />

      <div class="fav" v-if="playlist.isFavourite">
        <div class="text">
          <a class="fa fa-heart" aria-hidden="true" />
        </div>
      </div>
    </LazyImage>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';

import BodyPartsTimeIndicator from '@/elements/BodyPartsTimeIndicator';
import LazyImage from '@/components/LazyImage';
import Loader from '@/components/Loader';

export default {
  name: 'PlaylistCard',
  components: { BodyPartsTimeIndicator, LazyImage, Loader },
  computed: {
    ...mapGetters(['user']),
  },
  props: ['playlist', 'loading'],
};
</script>

<style scoped lang="scss">
.link {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.fav {
  position: absolute;
  top: 5px;
  right: 5px;

  height: 22px;
  width: 22px;
  padding: 1px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 44px;

  .text {
    font-size: 12px;
    line-height: 22px;
    background-color: rgb(160, 198, 77);
    border-radius: 40px;
    height: 20px;
    width: 20px;
    text-align: center;
  }

  a {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistCard/Mobile.vue